import { applyMiddleware, createStore } from 'redux';
import  reduxCookiesMiddleware  from 'redux-cookies-middleware';
import { getStateFromCookies } from 'redux-cookies-middleware';

 
import rootReducer from './reducers/index';

let initialState = {
  authStatus: 'ANONYMOUS',
  credentials: {
  	token: '',
  	username: ''
  }
};

const paths = {
	'authStatus': { name: 'audit.auth.authStatus' }, 
  'credentials.token': { name: 'audit.auth.token' },
  'credentials.username': { name: 'audit.auth.username' }
};

initialState = getStateFromCookies(initialState, paths);

const store = createStore(
  rootReducer, 
  initialState, 
  applyMiddleware(
    reduxCookiesMiddleware(paths)
  )
);

export default store;


// WEBPACK FOOTER //
// ./src/store/index.js